/**
 * Holt per AJAX jeweils eine weitere Seite Posts
 * und hängt sie ans entsprechende Grid an.
 *
 */
jQuery(function ($) {
  $(document).on('click', '[data-load-more]', function () {
    const $btn = $(this);
    const $label    = $btn.find('.btn-label');
    const $spinner  = $btn.find('.btn-spinner');
    const $grid = $($btn.data('blog-grid'));
    const nextPage = parseInt($btn.attr('data-next-page'), 10);
    const perPage = $grid.data('per-page');
    const category = $grid.data('category');
    const ajaxurl = $grid.data('ajax-url');
    const nonce = $grid.data('nonce');

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'load_more_posts',
        page: nextPage,
        perPage: perPage,
        category: category,
        nonce: nonce,
      },
      beforeSend: () => {
        $btn.prop('disabled', true);
        $label.css('opacity', 0);
        $spinner.removeClass('hidden');
      },
      success: (resp) => {
        if (!resp.success) return;

        const { has_more, next_page } = resp.data;
        const $html = $(resp.data.html);
        const $items = $html.filter('article').add( $html.find('article') );

        // 1) Startzustand (unsichtbar + versetzt) – ohne Transition
        $items
          .addClass('opacity-0 translate-y-10')
          .appendTo($grid);

        // 2) 1 Frame warten, dann Transition-Klassen aktivieren
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            $items
              .addClass('transition-opacity transition-transform duration-500 ease-in-out opacity-100 translate-y-0')
              .removeClass('opacity-0 translate-y-10');
          });
        });

        if (has_more) {
          finish(next_page);
        } else {
          $btn.remove(); // Button verschwindet, wenn alle Posts geladen sind
        }
      },
      error: () => {
      console.log('Error loading more posts');
      finish(nextPage);
    },
  });

    function finish(nextPage) {
      $spinner.addClass('hidden');
      $label.css('opacity', 1);
      $btn.attr('data-next-page', nextPage);
      $btn.prop('disabled', false);
    }

  });
});
